// Strong-password generator matching the identity server's password policy
// (digit + upper + lower + non-alphanumeric, ≥8 chars, ≥2 unique chars).
// We use crypto.getRandomValues for the random index so the password isn't
// guessable from the page load time.
const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";   // no I/O — easier to dictate
const LOWER = "abcdefghijkmnpqrstuvwxyz";   // no l/o
const DIGIT = "23456789";                   // no 0/1
// Only the symbols CreateUserRequest's complexity regex counts as special — "+=?" would
// satisfy the identity server's policy but not the signup flow's.
const SYMBOL = "!@#$%^&*";

function pick(alphabet: string, n: number, out: string[]): void {
  const buf = new Uint32Array(n);
  crypto.getRandomValues(buf);
  for (let i = 0; i < n; i++) {
    out.push(alphabet[buf[i] % alphabet.length]);
  }
}

function shuffle<T>(arr: T[]): T[] {
  const buf = new Uint32Array(arr.length);
  crypto.getRandomValues(buf);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = buf[i] % (i + 1);
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function generatePassword(): string {
  const chars: string[] = [];
  pick(UPPER, 4, chars);
  pick(LOWER, 4, chars);
  pick(DIGIT, 4, chars);
  pick(SYMBOL, 4, chars);
  return shuffle(chars).join("");
}
